// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .typing-indicator {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 12px 16px;
    }

    .typing-indicator span {
      height: 8px;
      width: 8px;
      background-color: #90a4ae;
      border-radius: 50%;
      display: inline-block;
      animation: typing 1.4s infinite ease-in-out both;
    }

    .typing-indicator span:nth-child(1) {
      animation-delay: -0.32s;
    }

    .typing-indicator span:nth-child(2) {
      animation-delay: -0.16s;
    }

    @keyframes typing {
      0%, 80%, 100% {
        transform: scale(0.6);
        opacity: 0.5;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/shared/typing-indicator/typing-indicator.component.ts"],"names":[],"mappings":";IACI;MACE,oBAAoB;MACpB,mBAAmB;MACnB,QAAQ;MACR,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,UAAU;MACV,yBAAyB;MACzB,kBAAkB;MAClB,qBAAqB;MACrB,gDAAgD;IAClD;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE;QACE,qBAAqB;QACrB,YAAY;MACd;MACA;QACE,mBAAmB;QACnB,UAAU;MACZ;IACF","sourcesContent":["\n    .typing-indicator {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      padding: 12px 16px;\n    }\n\n    .typing-indicator span {\n      height: 8px;\n      width: 8px;\n      background-color: #90a4ae;\n      border-radius: 50%;\n      display: inline-block;\n      animation: typing 1.4s infinite ease-in-out both;\n    }\n\n    .typing-indicator span:nth-child(1) {\n      animation-delay: -0.32s;\n    }\n\n    .typing-indicator span:nth-child(2) {\n      animation-delay: -0.16s;\n    }\n\n    @keyframes typing {\n      0%, 80%, 100% {\n        transform: scale(0.6);\n        opacity: 0.5;\n      }\n      40% {\n        transform: scale(1);\n        opacity: 1;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
